import { render, staticRenderFns } from "./AddCreditNote.vue?vue&type=template&id=12d796a4&scoped=true&"
import script from "./AddCreditNote.vue?vue&type=script&lang=js&"
export * from "./AddCreditNote.vue?vue&type=script&lang=js&"
import style0 from "./AddCreditNote.vue?vue&type=style&index=0&id=12d796a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d796a4",
  null
  
)

export default component.exports